import { time } from "console"
import React, { useContext, useEffect, useState } from "react"
import { finished } from "stream"
import styled from "styled-components"
import { AppContext } from "../../../../context/createContext"
import Cell from "./cell/Cell"
import typesOfJackpot from "./data"
import { joinArray } from "./helper"

export default function Grid({ handleCollect }: any) {
  const { jackpot, stellarSocketMessages } = useContext(AppContext)
  const selected = [
    "break cube",
    "break cube",
    "break cube",
    "break cube",
    "break cube",
    "break cube",
    "break cube",
    "break cube",
    "break cube",
  ]
  const [final, setFinal] = useState(joinArray(selected, typesOfJackpot))
  const [winType, setWinType] = useState("0")
  const [isWin, setIsWin] = useState(false)
  const [isClickable, setIsClickable] = useState(true)

  const handleBoard = () => {
    jackpot.board.forEach(function (item: any, i) {
      if (item === 0) selected[i] = "break cube"
      if (item === 1) selected[i] = "solar"
      if (item === 2) selected[i] = "galactical"
      if (item === 3) selected[i] = "stellar"
    })
    setFinal(joinArray(selected, typesOfJackpot))
    setIsClickable(true)
  }

  const handleJackpotStep = (socket: any, index: number) => {
    socket.jackpotStep(index)
  }
  const clickedOn = (index: number) => {
    setIsClickable(false)
    handleJackpotStep(stellarSocketMessages, index)
  }

  useEffect(() => {
    handleBoard()
  }, [jackpot.board])

  useEffect(() => {
    let timeout: any
    if (jackpot.status === "finished") {
      if (jackpot.wintype === 1) {
        setWinType("solar")
      }
      if (jackpot.wintype === 2) {
        setWinType("galactical")
      }
      if (jackpot.wintype === 3) {
        setWinType("stellar")
      }
      timeout = setTimeout(() => {
        setIsWin(true)
      }, 500)
    }
    return () => clearTimeout(timeout)
  }, [jackpot])

  return (
    <GridContainer>
      {final.map((cube: any, index: number) => (
        <Cell
          key={index}
          type={cube}
          index={index}
          clickedOn={clickedOn}
          winType={winType}
          isWin={isWin}
          handleCollect={handleCollect}
          isClickable={isClickable}
        />
      ))}
    </GridContainer>
  )
}

export const GridContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-column-gap: 20px;
  grid-row-gap: 20px;
  justify-items: stretch;
  align-items: stretch;
  @media only screen and (min-width: 768px) {
    grid-column-gap: 24px;
    grid-row-gap: 24px;
  }
  @media only screen and (min-width: 1024px) {
    grid-column-gap: 28px;
    grid-row-gap: 28px;
  }
  @media only screen and (min-width: 1024px) and (max-height: 640px) {
    grid-column-gap: 20px;
    grid-row-gap: 24px;
  }
`
